import React from "react";
import "./AdminDashboardHome.css";

export default function QuickActionCard({ icon, label, onClick, variant = "secondary" }) {
  return (
    <button
      type="button"
      className={`adh-quick-action adh-quick-action-${variant}`}
      onClick={onClick}
    >
      <span className="adh-quick-action-icon">
        <i className={`fa-solid ${icon}`} aria-hidden="true"></i>
      </span>
      <span className="adh-quick-action-label">{label}</span>
    </button>
  );
}
